import { atom } from 'jotai';
import { atomWithReset } from 'jotai/utils';

import {
  NewPatientDrawerState,
  NewPatientFromCheckinEntryDrawerState,
  NewPatientPanelMap,
  PatientPageInfo,
  PrescriptionQrCodeReaderDialog,
  SamePatientModal,
} from './types';

export const patientPageInfoState = atom<PatientPageInfo>({
  page: 1,
  totalPage: 1,
  totalCount: 0,
  perPage: 25,
  searchWord: null,
  latestMessageCreatedAt: null,
  answered: null,
  isFollowingUp: null,
  practitionerId: null,
  orderBy: { field: 'latest_message_created_at', direction: 'desc' },
});

export const newPatientDrawerState = atomWithReset<NewPatientDrawerState>({
  inputValue: null,
  qrCodePatient: null,
  isOpen: false,
  page: 1,
  perPage: 10,
  totalPage: 1,
  currentPanel: NewPatientPanelMap.input,
  existingPhoneNumber: false,
});

export const newPatientFromCheckinEntryDrawerState =
  atomWithReset<NewPatientFromCheckinEntryDrawerState>({
    isOpen: false,
    checkinEntryId: null,
  });

export const prescriptionQrCodeReaderDialogState = atomWithReset<PrescriptionQrCodeReaderDialog>({
  isOpen: false,
});

export const samePatientModalState = atomWithReset<SamePatientModal>({
  isOpen: false,
  patientId: null,
  guestPatientId: null,
});
